import React from "react";
import CKEditor from "react-ckeditor-component";
import "../../assets/css/Editor.css";

class CKEditorField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: this.props.value || "",
    };
    this.onChange = this.onChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value && this.props.value !== this.state.content) {
      this.setState({
        content: this.props.value || "",
      });
    }
  }

  onChange(evt) {
    var newContent = evt.editor.getData();
    this.setState({
      content: newContent,
    });
    this.props.onChange(newContent);
  }

  onBlur = (evt) => {
    // console.log("onBlur event: ", evt);
  };

  afterPaste = (evt) => {
    // console.log("afterPaste event: ", evt);
  };

  onFileUploadRequest = (evt) => {
    const fileLoader = evt.data.fileLoader;
    const formData = new FormData();
    const xhr = fileLoader.xhr;

    xhr.open("POST", fileLoader.uploadUrl, true);
    formData.append("file", fileLoader.file, fileLoader.fileName);
    fileLoader.xhr.send(formData);

    // Prevented the default behavior.
    evt.stop();
  };

  onFileUploadResponse = (evt) => {
    evt.stop();

    const data = evt.data;
    const xhr = data.fileLoader.xhr;
    const response = xhr.responseText.split("|");

    if (response[1]) {
      // An error occurred during upload.
      data.message = response[1];
      evt.cancel();
    } else {
      const responseData = JSON.parse(xhr.responseText);
      // Example response: { "file": "filename.jpg" }
      if (responseData && responseData.file) {
        data.url = this.props.uploadPreviewUrl + responseData.file;
      } else {
        // Assume response is the filename if not JSON or different structure (fallback)
        // Adjust based on actual server response if needed
         data.url = this.props.uploadPreviewUrl + (responseData.file || responseData);
      }
    }
  };

  render() {
    return (
      <CKEditor
        activeClass="p10"
        content={this.state.content}
        events={{
          blur: this.onBlur,
          afterPaste: this.afterPaste,
          change: this.onChange,
          fileUploadRequest: this.onFileUploadRequest,
          fileUploadResponse: this.onFileUploadResponse,
        }}
        config={{
          toolbar: "Full",
          allowedContent: true,
          filebrowserUploadUrl: this.props.uploadUrl,
          filebrowserImageUploadUrl: this.props.uploadUrl,
        }}
      />
    );
  }
}

export default CKEditorField;
